import { useCallback, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useReducedMotion from './useReducedMotion';

gsap.registerPlugin(ScrollToPlugin);

export default function useSectionNavigation() {
  const tween = useRef(null);
  const frame = useRef(null);
  const reduced = useReducedMotion();
  useEffect(() => () => { tween.current?.kill(); cancelAnimationFrame(frame.current); }, []);
  return useCallback((destination) => {
    tween.current?.kill(); cancelAnimationFrame(frame.current);
    // Let the drawer unmount and release its scroll lock first.
    frame.current = requestAnimationFrame(() => {
      const section = document.querySelector(destination);
      if (!section) return;
      tween.current = gsap.to(window, {
        scrollTo: { y: section, autoKill: true }, duration: reduced ? 0 : .95, ease: 'power3.inOut',
        onComplete: () => {
          ScrollTrigger.update();
          section.querySelector('h1, h2')?.focus({ preventScroll: true });
        },
      });
    });
  }, [reduced]);
}
